/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Preview_EndInputs */

const en_highlight_settings_preview_end = /** @type {(inputs: Highlight_Settings_Preview_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`word looks.`)
};

const es_highlight_settings_preview_end = /** @type {(inputs: Highlight_Settings_Preview_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "word looks." |
*
* @param {Highlight_Settings_Preview_EndInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_preview_end = /** @type {((inputs?: Highlight_Settings_Preview_EndInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Preview_EndInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_preview_end(inputs)
	return en_highlight_settings_preview_end(inputs)
});